<div class="loading-full-colibri offline-connectivity-modal-root">
  <app-navbar
    [showStartOver]="false"
    [status]="96"
    [showShortIcon]="true"
    [showSkyPriority]="false"
    [showLanguagesButton]="false"
  ></app-navbar>
  <div class="content bg-am-premium-blue offline-connectivity-modal__content">
    <div class="offline-connectivity-modal__panel">
      <h1 class="offline-connectivity-modal__title">
        {{ titleKey | translate }}
      </h1>
      <h2 class="offline-connectivity-modal__message">
        {{ messageKey | translate }}
      </h2>
      @if (subMessageKey) {
        <h5 class="offline-connectivity-modal__submessage">
          {{ subMessageKey | translate }}
        </h5>
      }
    </div>
  </div>
</div>
